export default __webpack_public_path__ + "static/media/ark.37c64269.jpeg";